






















import { Component, Mixins } from "vue-property-decorator";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { JoinTextObjectStyleReader } from "../styleReaders";
import { DrawableItemEditorMixin } from "../mixins";
import { PropertyEditableMixin, DrawerPropertyEditableMixin, TextDrawerPropertyEditableMixin, PainterPropertyEditableMixin } from "./mixins";
import TextStyleEditor from "../../../drawing/TextStyleEditor.vue";
import FillStyleEditor from "../../../drawing/FillStyleEditor.vue";
import PrintBehaviorEditor from "./PrintBehaviorEditor.vue";

@Component({
  components: {
    textStyleEditor: TextStyleEditor,
    fillStyleEditor: FillStyleEditor,
    printBehaviorEditor: PrintBehaviorEditor,
  },
})
export default class JoinTextPropertyEditor extends Mixins<
  PropertyEditableMixin
  & DrawableItemEditorMixin
  & DrawerPropertyEditableMixin
  & TextDrawerPropertyEditableMixin
  & PainterPropertyEditableMixin
>(
  PropertyEditableMixin,
  DrawableItemEditorMixin,
  DrawerPropertyEditableMixin,
  TextDrawerPropertyEditableMixin,
  PainterPropertyEditableMixin,
) {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new JoinTextObjectStyleReader(configuration.style.document.editor.objects.joinText);
  }
}
